// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"290":"9bfbfa94","637":"2fe26e82","886":"d27b51d6"}[chunkId] + ".chunk.css";
};